<div class="d-flex align-items-center justify-content-between top-header-hp">

  <!-- <div><a href="javascript:void(0)" class="brand-logo">
      <div class="header-left d-flex align-items-center" [routerLink]="roleId == 1 ? '/admin/AdminDash' : '/dashboard'">
        <img src="../../../assets/images/logos/hplogo.png" title="logo" width="50px">
        <div class="brand-title ps-2" style="color: #fff; font-size: 13px;">
          Department of Cooperation <br> Himachal Pradesh
        </div>

      </div>
    </a></div> -->
  <!-- ============================================================== -->
  <!-- toggle and nav items -->
  <!-- ============================================================== -->
  <!-- <div class="d-flex align-items-center">
  <div class="ps-2 py-2">
    <img src="../../../assets/images/logos/LogoHPCD.png" title="logo" width="50px">
  </div>
  <div class="ps-2 py-2">
    <img src="../../../assets/images/logos/statehood50logo.png" title="logo" width="50px">
  </div>
</div> -->
  <!-- ============================================================== -->
  <!-- Right side toggle and nav items -->
  <!-- ============================================================== -->
  <ul class="navbar-nav float-end">
    <!-- ============================================================== -->
    <!-- User profile and search -->
    <!-- ============================================================== -->

    <li class="nav-item" placement="bottom-end" *ngIf="!isAuthenticated">
      <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">
        <i class="bi bi-box-arrow-in-right"></i>
        <span class="ms-2">Login</span>
      </a>
    </li>
    <li class="nav-item notification-bell-content" ngbDropdown #notifDropdown="ngbDropdown" placement="bottom-end"
      *ngIf="isAuthenticated" (click)="toggleNotificationDropdown($event)">
      <a ngbDropdownToggle>
        <i class="fa fa-bell"></i>
        <span class="badge" *ngIf="notifications.length > 0">{{ notifications.length }}</span>
      </a>

      <div class="dropdown-menu-right notification-bell-body" ngbDropdownMenu>
        <!-- <div class="notification-bell-list">
<a class="dropdown-item" *ngFor="let notify of visibleNotifications">
        <div >
          <i [class]="notify.Icon" class="notify-iconss"></i> 
          <div class="d-flex align-items-center gap-1 justify-content-between">
          <h5>{{notify.ModuleName}}</h5>
          <div class="date">
              <span>{{notify.CreatedDate | date }}</span>
          </div>
</div>
          <p>{{notify.Message}}</p>
          <i class="fa fa-close notify-iconss-close" (click)="readNotification($event,notify.Id)"></i>      
        </div> 
          
        
      </a>
</div> -->


       <div class="notification-bell-list-content">
 <div class="notification-bell-list"
          *ngIf="visibleNotifications && visibleNotifications.length > 0; else noNotifications">
          <a class="dropdown-item" *ngFor="let notify of visibleNotifications">
            <div>
              <h5>{{ notify.ModuleName }}</h5>
              <p>{{ notify.Message }}</p>
            </div>
            <div class="date">{{ notify.CreatedDate | date:'MMM d, yyyy' }}</div>
            <i class="fa fa-close notify-iconss-close" (click)="readNotification($event, notify.Id)"></i>
          </a>

        </div>

        <ng-template #noNotifications>
          <div class="no-notification-message text-center" style="padding: 6.25rem !important;">
            <i class="fa fa-bell-slash" style="font-size: 20px; color: #aaa;"></i>
            <p class="mt-2 mb-0">No notifications</p>
          </div>
        </ng-template>

        <!-- <a class="dropdown-item text-center text-primary"
         *ngIf="notificationsList?.length > 0"
        (click)="viewMore(viewNotification)">
         View More
      </a> -->
        <a class="dropdown-item notification-bell-btn" *ngIf="notificationsList?.length > 0"
          [routerLink]="['dashboard/notification']">
          <span>View More</span>
        </a>

</div>
      </div>
    </li>

    <!-- <li class="nav-item" ngbDropdown placement="bottom-end" *ngIf="isAuthenticated">
      <a ngbDropdownToggle class="nav-link waves-effect waves-dark pro-pic d-flex align-items-center gap-1"
        href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div class="d-flex align-items-center gap-1" style="line-height: 18px; ">

          <div class="user-profile-image">
            <img src={{imageurl}} alt="user" *ngIf="imageurl" />
            <img src="../../../assets/images/users/user4.jpg" alt="user" *ngIf="!imageurl" />
          </div>
          <div>
            <span class="user-profile-title"
              style="max-width: 15ch; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; display:inline-block;"
              title="{{userName}}">{{userName}}</span><br>
            <span class="user-profile-subtitle"
              style="font-size: 13px; max-width: 12ch; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; display:block;"
              title="{{userrolename}}">{{userrolename}}</span>
          </div>
        </div>

      </a>
      <div class="dropdown-menu-right" ngbDropdownMenu>
        <a class="dropdown-item" href="/user-profile"><i class="bi bi-person"></i> My Profile</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="javascript:void(0)" (click)="logOut()"><i class="bi bi-box-arrow-right"></i>
          Logout</a>
      </div>
    </li> -->
    <!-- ============================================================== -->
    <!-- User profile and search -->
    <!-- ============================================================== -->
  </ul>
</div>
<ng-template #viewNotification let-modal>
  <div class="modal-header">
    <h4 class="modal-title">All Notifications</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-12">
        <hr>
        <div class="table-responsive">
          <table class="table table-hover align-middle text-nowrap table-bordered">
            <thead>
              <tr>
                <th class="text-dark font-medium">S.No.</th>
                <th class="text-dark font-medium">Module Name</th>
                <th class="text-dark font-medium">Message</th>
                <th class="text-dark font-medium">Created Date</th>
                <th class="text-dark font-medium">Created By</th>
                <!-- <th class="text-dark font-medium">View Date</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let notifi of notificationsList; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ notifi.Name }}</td>
                <td>{{ notifi.Message }}</td>
                <td>{{ notifi.CreatedDate }}</td>
                <td>{{ notifi.RoleName }}</td>
                <!-- <td>{{ notifi.ViewDate }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
  </div>
</ng-template>